import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function CoinAlert({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M20.21 13.21C20.7 12.24 20.99 11.15 20.99 9.98999C20.99 6.11999 17.85 2.98999 13.99 2.98999C12.83 2.98999 11.73 3.26999 10.77 3.77599M10.001 13.74V11.19M9.999 16.55C9.929 16.55 9.869 16.6 9.869 16.67C9.869 16.73 9.919 16.79 9.989 16.79C10.049 16.79 10.109 16.73 10.109 16.66C10.109 16.59 10.049 16.53 9.979 16.53M10 21C6.133 21 3 17.86 3 14C3 10.13 6.133 6.99999 10 6.99999C13.865 6.99999 17 10.135 17 14C17 17.86 13.86 21 10 21Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default CoinAlert;